import type { PositionPlanPositioningWrapperProps } from "./position-plan-positioning.type";

import PositionPlanPositioning from "./position-plan-positioning.component";

const PositionPlanPositioningWrapper = ({
  planSourceUrl,
  ...othersProps
}: PositionPlanPositioningWrapperProps) => {
  if (!planSourceUrl) return null;

  return (
    <PositionPlanPositioning planSourceUrl={planSourceUrl} {...othersProps} />
  );
};

export default PositionPlanPositioningWrapper;
